import { render, staticRenderFns } from "./players.vue?vue&type=template&id=bad6beda&scoped=true"
import script from "./players.vue?vue&type=script&lang=js"
export * from "./players.vue?vue&type=script&lang=js"
import style0 from "./players.vue?vue&type=style&index=0&id=bad6beda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad6beda",
  null
  
)

export default component.exports